import { GeoJSONTrafiken } from '../Layers/GeoJSONTrafiken';
import type { WinterBikeRoadsSthOptions } from '../Layers/Layers.types';
import WinterBikeRoadsSthTemplate from '../PopupTemplates/WinterBikeRoadsSthTemplate';
import { WinterBikeRoadsSthSource } from '../Sources/WinterBikeRoadsSthSource';

function winterBikeRoadsBase(
    name: string,
    municipality: string,
    color: string,
    updated: string,
    url: string,
    baseUrl: string,
    method: string,
    frequency?: string,
) {
    const defaultOptions: WinterBikeRoadsSthOptions = {
        name,
        municipality,
        updated,
        url,
        baseUrl,
        method,
        frequency,
        source: new WinterBikeRoadsSthSource(municipality),
        popupTemplate: WinterBikeRoadsSthTemplate,
        style: {
            color: color,
            weight: 3,
            fillOpacity: 0.4,
        },
    };

    return function (data?, options?: WinterBikeRoadsSthOptions) {
        return new GeoJSONTrafiken(data, { ...defaultOptions, ...options });
    };
}

export const winterBikeRoadsSolna = winterBikeRoadsBase(
    'Solna stad',
    'solna',
    '#8E9300',
    '2019-11-15',
    'https://www.solna.se/boende--miljo/trafik-och-framkomlighet/skotsel-av-stadens-vagar/snorojning-och-halkbekampning/',
    'www.solna.se',
    'Sopsaltning. Snöröjning vid snödjup 3 cm. Halkbekämpning i samband med snöröjning och i övrigt vid risk för halka.',
    'Klart inom två timmar.',
);
export const winterBikeRoadsSollentuna = winterBikeRoadsBase(
    'Sollentuna kommun',
    'sollentuna',
    '#666666',
    '2020-01-13',
    'https://www.sollentuna.se/trafik--stadsplanering/Cykel/Cykelpumpar/Ny-metod-for-snorojning-av-cykelbanor/',
    'www.sollentuna.se',
    'Sopsaltning. Snön borstas bort från cykelbanan och att ett salt läggs ut för att motverka att snö och is bildas. Det innebär att cykelbanan hålls helt ren från snö och is och att det blir barmarksförhållanden. Det innebär också att cykelbanan hålls fri från grus och skräp vilket är en vanlig orsak till cykelolyckor, särskilt på våren.',
);
export const winterBikeRoadsNacka = winterBikeRoadsBase(
    'Nacka kommun',
    'nacka',
    '#ED5923',
    '2019-12-19',
    'https://www.nacka.se/stadsutveckling-trafik/cykla-i-nacka/cykla-pa-vintern/',
    'www.nacka.se',
    'Sopsaltning. Använder sopsaltare som dras av en plogmaskin. Sopsaltaren har en sopvals (borste) längst fram som borstar bort snö och annat som inte plogen får bort. Längst bak på sopsaltaren sitter ett ramp med munstycken som sprutar ut saltlösning.',
    'Så ofta det behövs. Oftast sker första körningen 03-04 för att pendlingsvägen ska vara i bra skick. Vid 16 går vi ut för hemåt pendlarna. Därutöver efterbehov vid snöfall eller temperaturväxlingar. Frekvens: 2-5 ggr per dag.',
);
export const winterBikeRoadsStockholm = winterBikeRoadsBase(
    'Stockholm stad',
    'stockholm',
    '#5D237D',
    '2021-12-02',
    'https://cykla.stockholm/underhall-av-cykelbanor/',
    'cykla.stockholm',
    'Sopsaltning. Sopsaltning innebär att snön sopas och saltas istället för att använda sand eller grus. För att kunna hålla nere saltmängden och minska risken för slaskbildning och återfrysning sopas ytan ren från snö innan saltet läggs på. Förutom sandsopning efter de prioriterade cykelstråken sker underhåll av  vägbanan. Vi underhåller även belysning.',
    'Använder sopsaltningsmaskinen när temperatur och väder tillåter. Blir väderförhållandena tuffa eller att temperaturen blir lägre än – 8 grader blir det traditionell snöröjning med plogning och sandning.',
);
export const winterBikeRoadsLidingo = winterBikeRoadsBase(
    'Lidingö stad',
    'lidingo',
    '#007AC3',
    '2021-01-14',
    'https://www.lidingo.se/toppmeny/trafikinfrastruktur/trafik/vintervaghallning.4.27003d4c1442ce73a164a4.html',
    'www.lidingo.se',
    'Efter en provperiod med sopsaltning har Lidingö stad återgått till traditionell plogning och halkbekämpning från om med vintersäsongen 2020/2021.',
    'Gång- och cykelvägar är fortsatt prioriterade, vilket innebär att de snöröjs när det kommit 2 centimeter snö. Gång- och cykelvägar sandas.',
);
export const winterBikeRoadsDanderyd = winterBikeRoadsBase(
    'Danderyds kommun',
    'danderyd',
    '#E53138',
    '2019-12-18',
    'https://www.danderyd.se/trafik-och-resor/trafik-och-gator/cykla-i-danderyd/cykla-pa-vintern/',
    'www.danderyd.se',
    'Sopsaltning. Sopsaltning innebär att snön sopas och saltas istället för att använda sand eller grus. För att kunna hålla nere saltmängden och minska risken för slaskbildning och återfrysning sopas ytan ren från snö innan saltet läggs på. Vi har olika maskiner för sopsaltning, de största klarar att ploga, sopa och salta samtidigt.',
    'Normalt 2 gånger per dygn, en inför morgontrafiken och en inför eftermiddagstrafiken, när risk för halka föreligger. Blir väderförhållandena tuffa eller att temperaturen blir lägre än ca - 8 grader i vägytan (ej luften) blir det traditionell snöröjning med plogning och sandning.',
);
